import React from "react";
import Sharingan from "../ItachiEyePassword/itachiEyePassword";
import PasswordStrength from "./PasswordStrength";
import ValidationError from "./ValidationError";
import PasswordRequirements from "./PasswordRequirements";

export default function PasswordInput({
  password,
  setPassword,
  showPassword,
  handleSharinganClick,
  validation,
  errors,
  allValid,
}) {
  return (
    <>
      <div className="sp-form-input-pass-wrapper">
        <div className="sp-form-input-pass">
          <input
            className={`form-input-pass ${errors?.length ? "input-error" : ""}`}
            style={{
              fontFamily: showPassword
                ? "comica, cursive"
                : "Courier New, monospace",
            }}
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <label className="form-floating-label-pass" htmlFor="password">
            PASSWORD
          </label>
          <Sharingan onLoginClick={handleSharinganClick} />
        </div>

        {/* Show password strength meter */}
        <PasswordStrength allValid={allValid} />
      </div>

      {/* Show validation error messages */}
      {errors && <ValidationError errors={errors} />}

      {/* Show password requirement checklist */}
      <PasswordRequirements validation={validation} />
    </>
  );
}
